import { render, staticRenderFns } from "./MemberCollect.vue?vue&type=template&id=2f46c5a6&scoped=true&"
import script from "./MemberCollect.vue?vue&type=script&lang=js&"
export * from "./MemberCollect.vue?vue&type=script&lang=js&"
import style0 from "./MemberCollect.vue?vue&type=style&index=0&id=2f46c5a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f46c5a6",
  null
  
)

export default component.exports